import { Inline, Stack } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";
import { useGetFormattedPostUntil } from "PFCore/helpers/use_get_formatted_post_until";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import { Activity } from "PFCore/types/activity";
import { useTranslation } from "react-i18next";

import css from "./activity_details_common.module.scss";

type ActivityResourcingDatesProps = {
  activity: Activity;
};

export const ActivityResourcingDates = ({ activity }: ActivityResourcingDatesProps) => {
  const { t } = useTranslation(["activities", "translation"]);

  const { formatDate } = useDateFormatter();

  const createdAt = formatDate(activity.created_at);

  const { timeHeader, timeValue } = useGetFormattedPostUntil(activity.post_until);

  return (
    <Stack qaId="ActivitySummary-ResourcingDates">
      <Typography variant="bodyBold">{t("activities:show.details.resourcingDates")}</Typography>
      <Inline justifyContent="space-between">
        {timeHeader && (
          <Stack className={css.resourcingDateItem}>
            <Typography variant="labelRegular">{timeHeader}</Typography>
            <Typography variant="bodyBold">{timeValue}</Typography>
          </Stack>
        )}
        <Stack className={css.resourcingDateItem}>
          <Typography variant="labelRegular">{t("translation:createdAt")}</Typography>
          <Typography variant="bodyBold">{createdAt}</Typography>
        </Stack>
      </Inline>
    </Stack>
  );
};
